import { Box } from '@chakra-ui/react';
import { ReactNode } from 'react';

import { ButtonIcon } from 'shared';
import { Flex } from 'shared_DEPRECATED/components/Flex';
import { Icon, iconNames } from 'shared_DEPRECATED/components/Icon';

import { AudioRecorderLiveIcon } from './LiveIcon';
import { AudioRecorderStopwatchTimer } from './StopwatchTimer';

const RECORDING_LIMIT_SECONDS = 600; // 10 mins;

type RecordAudioProps = {
  onRecordingStop: () => void;
  onRecordingCancel: () => void;
  isRecordingPaused: boolean;
  children?: ReactNode;
};

export const AudioRecorder = ({
  onRecordingStop,
  onRecordingCancel,
  children,
  isRecordingPaused,
}: RecordAudioProps) => {
  return (
    <Box
      style={{
        backgroundColor: 'var(--bgPrimary)',
        borderRadius: '24px',
        padding: '4px 16px',
        width: '100%',
      }}
    >
      <Flex justifyContent="space-between">
        <Flex gap="var(--spacing03)">
          <AudioRecorderLiveIcon />
          <AudioRecorderStopwatchTimer
            onStop={onRecordingStop}
            isRunning={!isRecordingPaused}
            timerLimit={RECORDING_LIMIT_SECONDS}
          />
        </Flex>
        <Flex gap="var(--spacing01)">
          <ButtonIcon
            aria-label="cancel-audio-recording"
            onClick={onRecordingCancel}
          >
            <Icon
              name={iconNames.binFilled}
              fill="var(--fgDanger)"
              height="20px"
              width="20px"
            />
          </ButtonIcon>
          {children}
        </Flex>
      </Flex>
    </Box>
  );
};
